import {useState} from 'react';
import {Box} from '@mui/material';
import HoldPasswordField from './HoldPasswordField';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';

export function passwordIssues(password: string, recovery = false) {
    return [
        password.length < 10 ? 'password_too_short' : '',
        password.length > (recovery ? 128 : 200) ? 'password_too_long' : '',
        !(recovery ? /\p{Lu}/u : /[A-Z]/).test(password) ? 'password_missing_uppercase' : '',
        !(recovery ? /\p{Ll}/u : /[a-z]/).test(password) ? 'password_missing_lowercase' : '',
        !/[0-9]/.test(password) ? 'password_missing_digit' : '',
        !(recovery ? /[^\p{L}\p{N}\s]/u : /[^A-Za-z0-9]/).test(password) ? 'password_missing_special' : '',
    ].filter(Boolean);
}

export default function RegistrationPasswordFields({password, confirmPassword, onPasswordChange, onConfirmPasswordChange, recovery = false, submitted = false, disabled = false, passwordError, confirmationError}: {
    password: string; confirmPassword: string;
    onPasswordChange: (value: string) => void; onConfirmPasswordChange: (value: string) => void;
    recovery?: boolean; submitted?: boolean; disabled?: boolean; passwordError?: string; confirmationError?: string;
}) {
    const {t} = useAppTranslation();
    const [passwordTouched, setPasswordTouched] = useState(false);
    const [confirmationTouched, setConfirmationTouched] = useState(false);
    const issues = passwordTouched || submitted ? passwordIssues(password, recovery) : [];
    const mismatch = (confirmationTouched || submitted) && (!confirmPassword || password !== confirmPassword);
    return <>
        <HoldPasswordField required disabled={disabled} name="newPassword" autoComplete="new-password" label={t(recovery ? 'auth:recovery.new_password' : 'registration:password')}
            value={password} onChange={event => onPasswordChange(event.target.value)} onBlur={() => setPasswordTouched(true)}
            inputProps={{minLength: 10, maxLength: recovery ? 128 : 200}} error={issues.length > 0 || !!passwordError}
            helperText={<>
                <Box component="span" sx={{display: 'block', textAlign: 'right'}}>{password.length}/10</Box>
                {passwordError && <Box component="span" sx={{display: 'block'}}>{passwordError}</Box>}
                {issues.length ? issues.map(issue => <Box component="span" key={issue} sx={{display: 'block'}}>{issue === 'password_too_long' && recovery ? t('auth:recovery.policy') : t(`registration:${issue}` as never)}</Box>) : t(recovery ? 'auth:recovery.policy' : 'registration:password_requirements')}
            </>}/>
        <HoldPasswordField required disabled={disabled} name="confirmPassword" autoComplete="new-password" label={t(recovery ? 'auth:recovery.confirm_password' : 'registration:confirm_password')}
            value={confirmPassword} onChange={event => onConfirmPasswordChange(event.target.value)} onBlur={() => setConfirmationTouched(true)}
            inputProps={{maxLength: recovery ? 128 : 200}} error={mismatch || !!confirmationError} helperText={mismatch ? t(recovery ? 'auth:recovery.mismatch' : 'registration:password_mismatch') : confirmationError}/>
    </>;
}
